import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TransportProvider } from "@connectrpc/connect-query";

import { App } from "@/App";
import { transport } from "@/lib/transport";
import "@/index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Nothing here is worth a retry storm: a permission error will not become
      // a success on the second try, and the panels are cheap to refresh by
      // hand. One retry covers the genuinely transient case.
      retry: 1,
      refetchOnWindowFocus: true,
      staleTime: 5_000,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TransportProvider transport={transport}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </TransportProvider>
  </StrictMode>,
);
